import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Paper } from '@mui/material';
import {loginUser} from "../services/api";

const LoginForm = () => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = await loginUser(formData);
            localStorage.setItem('token', data.token);
            localStorage.setItem('role', data.role);
            window.location.href = '/';
        } catch (error) {
            console.error('Erreur lors de la connexion :', error);
            setError('Erreur de connexion. Veuillez réessayer.');
        }
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex basique pour les emails
        return emailRegex.test(email);
    };



    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{ padding: 2 }}>
                <Typography variant="h5" gutterBottom>
                    Connexion
                </Typography>
                {error && <Typography color="error">{error}</Typography>}
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Mot de passe"
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={!formData.email || !formData.password || !isValidEmail(formData.email)} // Désactive si l'email est invalide
                    >
                        Se connecter
                    </Button>


                </form>
            </Paper>
        </Container>
    );
};

export default LoginForm;
